/* cache-bump 2026-08-03b: same stale-CDN-entry fix as bundles-app.js. This file carries a
   byte-identical BUNDLE_PRICING table, so it was serving the same pre-AMOM200 pricing.
   Exists only to change the checksum and force a fresh asset URL. Safe to delete later. */
/* pdp-bundle-module.jsx — brings the two best Bundles-page sections onto the
   Gut X PDP without competing with the individual-product sale:
     • Popular stacks (reordered so the current product leads the grid)
     • the full Barn Plan wizard
   Adds a modern slide-out CART DRAWER: "Add stack" / "Add this plan" MERGE into
   the cart (never wipe what's there) and the drawer slides out with full controls
   (qty, remove, purchase type, cadence, checkout) + a "View cart & add more" link
   back to the Bundles page. Pricing engine + catalog are ported verbatim from
   bundles-app.jsx (the canonical source).                                        */
(function () {
  const {
    useState,
    useEffect
  } = React;
  const money = n => '$' + n.toFixed(2);
  const round2 = n => Math.round(n * 100) / 100;
  const CURRENT_KEY = 'gut-x'; // this PDP's product — leads the stacks grid

  function useAnimatedNumber(value, dur = 480) {
    const [disp, setDisp] = React.useState(value);
    const fromRef = React.useRef(value);
    React.useEffect(() => {
      const from = fromRef.current,
        to = value,
        start = performance.now();
      if (from === to) return;
      let raf;
      const tick = now => {
        const p = Math.min(1, (now - start) / dur);
        const e = 1 - Math.pow(1 - p, 3);
        setDisp(from + (to - from) * e);
        if (p < 1) raf = requestAnimationFrame(tick);else fromRef.current = to;
      };
      raf = requestAnimationFrame(tick);
      const settle = setTimeout(() => {
        setDisp(to);
        fromRef.current = to;
      }, dur + 80);
      return () => {
        cancelAnimationFrame(raf);
        clearTimeout(settle);
        fromRef.current = to;
      };
    }, [value]);
    return disp;
  }

  /* ---- Catalog (verbatim from bundles-app.jsx) ---- */
  const PRODUCTS = [{
    key: 'gut-x',
    name: 'Gut X',
    cat: 'Gut & Immune',
    unit: '1 gallon · ~30 day supply',
    bestFor: 'Every horse, as the foundation',
    daysPerUnit: 128,
    msrp: 134.79,
    tiers: [{
      q: 2,
      price: 212.56
    }, {
      q: 4,
      price: 402.56
    }],
    icon: 'shield',
    accent: '#ED5757',
    img: window.BA["cfJ8qBBg.webp"]
  }, {
    key: 'osteo-max',
    name: 'Osteo-MAX',
    cat: 'Joint, Soft Tissue & Bone',
    unit: '1 gallon · ~30 day supply',
    bestFor: 'Performance & aging horses',
    daysPerUnit: 128,
    msrp: 231.56,
    tiers: [{
      q: 2,
      price: 414.44
    }, {
      q: 4,
      price: 700.63
    }],
    icon: 'bone',
    accent: '#5B6B8C',
    img: window.BA["4DmYmZBg.webp"],
    photo: 'Osteo-MAX'
  }, {
    key: 'joint-flex-plus',
    name: 'Joint Flex Plus',
    cat: 'Mobility',
    unit: '1 gallon · ~30 day supply',
    bestFor: 'Everyday mobility',
    daysPerUnit: 128,
    msrp: 134.79,
    tiers: [{
      q: 2,
      price: 212.56
    }, {
      q: 4,
      price: 402.56
    }],
    icon: 'activity',
    accent: '#3F9E94',
    img: window.BA["joint-flex-plus.jpg"]
  }, {
    key: 'amino-max',
    name: 'Amino-MAX',
    cat: 'Topline & Muscle',
    unit: '1 gallon · ~30 day supply',
    bestFor: 'Topline & muscle',
    daysPerUnit: 128,
    // 2026-08-03 Doug: Amino 2-gallon base cut $279 -> $253 (15% off two singles, up from 6%),
    // fixing the 3-vs-4 gallon inversion from the 2-gallon side so the 4-gallon subscriber dollar
    // stays held at $379.05. 15% not 21% because Amino has the highest COGS in the line.
    // Launch ladder: 176.94 / 300.44 / 450.66 / 473.81. See bundles-app.js for the full note;
    // that file carries its own copy of this ladder and the two must change together.
    msrp: 176.94,
    tiers: [{
      q: 2,
      price: 300.44
    }, {
      q: 4,
      price: 473.81
    }],
    icon: 'trend',
    accent: '#C98A2E',
    img: window.BA["aminomax-gal-horse.webp"],
    photo: 'Amino-MAX'
  }, {
    key: 'hydra-max',
    name: 'Hydra-MAX',
    cat: 'Electrolytes + Creatine',
    unit: 'Bucket · 32 servings',
    bestFor: 'Sweat, travel & heat',
    daysPerUnit: 30,
    msrp: 117.56,
    tiers: [{
      q: 2,
      price: 224.44
    }],
    icon: 'drop',
    accent: '#3E92C7',
    img: window.BA["hydramax-hero-barn.webp"],
    photo: 'Hydra-MAX'
  }, {
    key: 'max-calm',
    name: 'Max Calm',
    cat: 'Calm & Focus',
    unit: '1 gallon · ~30 day supply',
    bestFor: 'Show & sale horses',
    daysPerUnit: 128,
    msrp: 134.79,
    tiers: [{
      q: 2,
      price: 212.56
    }, {
      q: 4,
      price: 402.56
    }],
    icon: 'moon',
    accent: '#7E9460',
    img: window.BA["100X_Content-376.jpg"]
  }];
  const BY_KEY = Object.fromEntries(PRODUCTS.map(p => [p.key, p]));
  const BUNDLE_PRICING = [{
    sku: 'OMGX200',
    items: {
      'osteo-max': 1,
      'gut-x': 1
    },
    price: 338.44
  }, {
    sku: 'OMGX400',
    items: {
      'osteo-max': 2,
      'gut-x': 2
    },
    price: 587.81
  }, {
    sku: 'OMGX800',
    items: {
      'osteo-max': 4,
      'gut-x': 4
    },
    price: 1128.13
  }, {
    sku: 'JFGX200',
    items: {
      'joint-flex-plus': 1,
      'gut-x': 1
    },
    price: 212.56
  }, {
    sku: 'JFGX400',
    items: {
      'joint-flex-plus': 2,
      'gut-x': 2
    },
    price: 402.56
  }, {
    sku: 'AMMC200',
    items: {
      'amino-max': 1,
      'max-calm': 1
    },
    price: 295.69
  }, {
    sku: 'AMMC400',
    items: {
      'amino-max': 2,
      'max-calm': 2
    },
    price: 473.81
  }, {
    sku: 'AMGX200',
    items: {
      'amino-max': 1,
      'gut-x': 1
    },
    price: 295.69
  }, {
    sku: 'MCGX200',
    items: {
      'max-calm': 1,
      'gut-x': 1
    },
    price: 212.56
  }, {
    sku: 'OMMC200',
    items: {
      'osteo-max': 1,
      'max-calm': 1
    },
    price: 338.44
  }, {
    sku: 'AMOM200',
    items: {
      'amino-max': 1,
      'osteo-max': 1
    },
    // ACTIVATED 2026-08-03. Was pending:true because the product was unpublished to the Online
    // Store, so its variant could not be added to a cart and bestCover had to route Amino+Osteo
    // through singles (costing the customer $17.81). Doug published it to all channels and set
    // its Recharge plans to 20%. Verified live: one-time $390.69, subscribe $312.55.
    // NOTE: this table is byte-identical to the one in bundles-app.js. Change both together.
    price: 390.69
  }, {
    sku: 'AMGXOM',
    items: {
      'amino-max': 1,
      'gut-x': 1,
      'osteo-max': 1
    },
    price: 497.56
  }];

  /* ---- Pricing engine (verbatim) ---- */
  function productPrice(p, q) {
    if (q <= 0) return 0;
    const tmap = {
      1: p.msrp
    };
    (p.tiers || []).forEach(t => {
      tmap[t.q] = t.price;
    });
    const t1 = tmap[1],
      t2 = tmap[2],
      t4 = tmap[4];
    if (q === 1) return t1;
    if (t2 == null) return t1 * q;
    if (q === 2) return t2;
    if (t4 == null) return t2 + (q - 2) * (t2 / 2);
    if (q === 3) return t2 + t2 / 2;
    if (q === 4) return t4;
    return t4 + (q - 4) * (t4 / 4);
  }
  const ACTIVE_BUNDLES = BUNDLE_PRICING.filter(b => !b.pending);
  function bestPrice(cart, memo) {
    memo = memo || {};
    const entries = Object.entries(cart).filter(e => e[1] > 0).sort();
    if (entries.length === 0) return 0;
    const key = JSON.stringify(entries);
    if (key in memo) return memo[key];
    let best = entries.reduce((s, e) => s + productPrice(BY_KEY[e[0]], e[1]), 0);
    for (const b of ACTIVE_BUNDLES) {
      if (Object.entries(b.items).every(it => (cart[it[0]] || 0) >= it[1])) {
        const next = {
          ...cart
        };
        for (const it of Object.entries(b.items)) next[it[0]] -= it[1];
        const cost = b.price + bestPrice(next, memo);
        if (cost < best) best = cost;
      }
    }
    memo[key] = best;
    return best;
  }
  const SUB_DISCOUNT = 0.20;

  // Same bridge to gx-bundle-checkout.js that bundles-app.js exposes. Shop and the Bundles page can
  // mount this drawer without the builder, so without this the checkout resolver would have no
  // pricing data on those pages. Guarded with || so the builder's copy wins when both load (home /
  // Bundles page); the two tables are kept byte-identical, so either source decomposes a cart the
  // same way.
  try {
    window.GX_BUNDLE_DATA = window.GX_BUNDLE_DATA || {
      byKey: BY_KEY,
      bundles: ACTIVE_BUNDLES,
      sub: SUB_DISCOUNT,
      productPrice: productPrice
    };
  } catch (e) {}
  function priceCart(cart, mode) {
    const keys = Object.keys(cart).filter(k => cart[k] > 0);
    const distinct = keys.length;
    let retail = 0,
      units = 0;
    keys.forEach(k => {
      retail += BY_KEY[k].msrp * cart[k];
      units += cart[k];
    });
    retail = round2(retail);
    const oneVol = round2(bestPrice(cart));
    const subVol = round2(oneVol * (1 - SUB_DISCOUNT));
    const base = mode === 'sub' ? subVol : oneVol;
    const total = base;
    const volSavePart = round2(retail - oneVol);
    const subSavePart = mode === 'sub' ? round2(oneVol - subVol) : 0;
    const save = round2(retail - total);
    const pct = retail > 0 ? save / retail : 0;
    const perUnit = units > 0 ? total / units : 0;
    const lines = {};
    if (keys.length) {
      const weights = keys.map(k => productPrice(BY_KEY[k], cart[k]));
      const wsum = weights.reduce((a, b) => a + b, 0);
      const raw = keys.map((k, i) => wsum > 0 ? base * weights[i] / wsum : base / keys.length);
      const floored = raw.map(v => Math.floor(v * 100) / 100);
      let leftover = Math.round((base - floored.reduce((a, b) => a + b, 0)) * 100);
      const order = raw.map((v, i) => [i, v * 100 - Math.floor(v * 100)]).sort((a, b) => b[1] - a[1]);
      for (let n = 0; n < leftover; n++) floored[order[n % order.length][0]] += 0.01;
      keys.forEach((k, i) => {
        lines[k] = round2(floored[i]);
      });
    }
    return {
      keys,
      distinct,
      units,
      base,
      retail,
      oneVol,
      subVol,
      total,
      save,
      pct,
      perUnit,
      subSavePart,
      volSavePart,
      lines
    };
  }
  const PROD_ICONS = {
    shield: '<path d="M12 3l7 3v5c0 4.6-3 7.8-7 9-4-1.2-7-4.4-7-9V6l7-3z"/><path d="M9 12l2 2 4-4"/>',
    bone: '<path d="M14.8 4.6a2.1 2.1 0 0 1 3 3 2.1 2.1 0 0 1-.5 3.3l-6.4 6.4A2.1 2.1 0 0 1 7 20.4a2.1 2.1 0 0 1-3-3 2.1 2.1 0 0 1 .5-3.3l6.4-6.4A2.1 2.1 0 0 1 14.8 4.6z"/>',
    activity: '<polyline points="3 12 7 12 10 5 14 19 17 12 21 12"/>',
    trend: '<polyline points="4 17 9 11 13 14 20 6"/><polyline points="15 6 20 6 20 11"/>',
    drop: '<path d="M12 3.5s6 5.6 6 10.1a6 6 0 0 1-12 0c0-4.5 6-10.1 6-10.1z"/>',
    moon: '<path d="M20.5 13.2A8 8 0 1 1 11 3.4a6.2 6.2 0 0 0 9.5 9.8z"/>'
  };
  function PlanGlyph({
    p
  }) {
    return /*#__PURE__*/React.createElement("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      dangerouslySetInnerHTML: {
        __html: PROD_ICONS[p.icon] || ''
      }
    });
  }
  function PlanMini({
    value,
    onChange,
    max
  }) {
    return /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-mini"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: () => onChange(Math.max(0, value - 1)),
      "aria-label": "Fewer"
    }, "–"), /*#__PURE__*/React.createElement("span", null, value), /*#__PURE__*/React.createElement("button", {
      onClick: () => onChange(max == null ? value + 1 : Math.min(max, value + 1)),
      "aria-label": "More"
    }, "+"));
  }

  /* ---------------- Barn plan wizard (verbatim behavior) ---------------- */
  function BarnPlanner({
    onApply,
    onStep
  }) {
    const [step, setStep] = useState(1);
    const [barn, setBarn] = useState(3);
    const [picked, setPicked] = useState([]);
    const [levels, setLevels] = useState({});
    const [events, setEvents] = useState(4);
    React.useEffect(() => {
      if (onStep) onStep(step);
    }, [step, onStep]);
    React.useEffect(() => {
      setLevels(l => {
        const m = {};
        Object.keys(l).forEach(k => {
          const perf = Math.min(l[k].perf || 0, barn);
          m[k] = {
            perf,
            maint: barn - perf
          };
        });
        return m;
      });
    }, [barn]);
    const toggle = k => {
      setPicked(p => {
        if (p.includes(k)) {
          setLevels(l => {
            const m = {
              ...l
            };
            delete m[k];
            return m;
          });
          return p.filter(x => x !== k);
        }
        setLevels(l => ({
          ...l,
          [k]: l[k] || {
            maint: barn,
            perf: 0
          }
        }));
        return [...p, k];
      });
    };
    const setLvl = (k, field, val) => setLevels(l => {
      const cur = l[k] || {
        maint: barn,
        perf: 0
      };
      const v = Math.max(0, Math.min(barn, val));
      const other = field === 'maint' ? 'perf' : 'maint';
      return {
        ...l,
        [k]: {
          [field]: v,
          [other]: barn - v
        }
      };
    });
    const planCart = {};
    picked.forEach(k => {
      const lv = levels[k] || {
        maint: barn,
        perf: 0
      };
      const weighted = lv.maint + 2 * lv.perf;
      if (weighted <= 0) return;
      const days = BY_KEY[k].daysPerUnit || 30;
      planCart[k] = Math.max(1, Math.ceil(90 * weighted / days));
    });
    const planKeys = Object.keys(planCart);
    const STRESS_KEYS = ['gut-x', 'max-calm', 'hydra-max'];
    const EVENT_DAYS = 10,
      EVENT_DOSE = 2,
      EVENT_OZ = EVENT_DAYS * EVENT_DOSE;
    const reserveCart = {};
    picked.forEach(k => {
      if (!STRESS_KEYS.includes(k) || events <= 0) return;
      const lv = levels[k] || {
        maint: barn,
        perf: 0
      };
      const affected = lv.maint;
      if (affected <= 0) return;
      const days = BY_KEY[k].daysPerUnit || 30;
      const weighted = lv.maint + 2 * lv.perf;
      const surplusOz = (planCart[k] || 0) * days - weighted * 90;
      const cycleEvents = events * 90 / 365;
      const reserveOz = cycleEvents * EVENT_OZ * affected;
      const extraNeeded = reserveOz - Math.max(0, surplusOz);
      const u = extraNeeded > 0 ? Math.ceil(extraNeeded / days) : 0;
      if (u > 0) reserveCart[k] = u;
    });
    const finalCart = {
      ...planCart
    };
    Object.entries(reserveCart).forEach(([k, u]) => {
      finalCart[k] = (finalCart[k] || 0) + u;
    });
    const finalKeys = Object.keys(finalCart);
    const hasStressMaint = picked.some(k => STRESS_KEYS.includes(k) && (levels[k] || {
      maint: barn
    }).maint > 0);
    const pr = priceCart(finalCart, 'sub');
    const Steps = /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-steps"
    }, ['Your barn', 'Protocols', 'Levels'].map((lab, i) => {
      const n = i + 1;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: lab
      }, i > 0 && /*#__PURE__*/React.createElement("span", {
        className: "bx-plan-rule"
      }), /*#__PURE__*/React.createElement("span", {
        className: 'bx-plan-step' + (step === n ? ' on' : step > n ? ' done' : '')
      }, /*#__PURE__*/React.createElement("span", {
        className: "n"
      }, step > n ? '\u2713' : n), /*#__PURE__*/React.createElement("span", {
        className: "lab"
      }, lab)));
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: "bx-plan"
    }, Steps, step === 1 && /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-q"
    }, /*#__PURE__*/React.createElement("h3", null, "How many horses are in your barn?"), /*#__PURE__*/React.createElement("p", null, "We’ll build a plan sized to your whole barn, not just one horse."), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-bignum"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: () => setBarn(Math.max(1, barn - 1)),
      "aria-label": "Fewer horses"
    }, "–"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, barn, /*#__PURE__*/React.createElement("small", null, barn > 1 ? 'horses' : 'horse')), /*#__PURE__*/React.createElement("button", {
      onClick: () => setBarn(barn + 1),
      "aria-label": "More horses"
    }, "+")), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-nav"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bx-btn bx-btn-primary",
      onClick: () => setStep(2)
    }, "Continue"))), step === 2 && /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-q"
    }, /*#__PURE__*/React.createElement("h3", null, "What does your barn need support with?"), /*#__PURE__*/React.createElement("p", null, "Pick the areas that matter for your horses. We’ll match each to a protocol and size it on the next step."), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-pick"
    }, PRODUCTS.map(p => {
      const on = picked.includes(p.key);
      return /*#__PURE__*/React.createElement("button", {
        key: p.key,
        className: 'bx-plan-opt' + (on ? ' on' : ''),
        onClick: () => toggle(p.key)
      }, /*#__PURE__*/React.createElement("span", {
        className: "ic",
        style: {
          background: p.accent
        }
      }, /*#__PURE__*/React.createElement(PlanGlyph, {
        p: p
      })), /*#__PURE__*/React.createElement("span", {
        className: "tx"
      }, /*#__PURE__*/React.createElement("span", {
        className: "nm"
      }, p.name), /*#__PURE__*/React.createElement("span", {
        className: "bf"
      }, p.cat)), /*#__PURE__*/React.createElement("span", {
        className: 'chk' + (on ? ' on' : '')
      }, on ? '\u2713' : '+'));
    })), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-nav"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bx-plan-ghost",
      onClick: () => setStep(1)
    }, "Back"), /*#__PURE__*/React.createElement("button", {
      className: "bx-btn bx-btn-primary",
      disabled: picked.length === 0,
      onClick: () => setStep(3)
    }, "Continue"))), step === 3 && /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-q"
    }, /*#__PURE__*/React.createElement("h3", null, "How many horses are on each level?"), /*#__PURE__*/React.createElement("p", null, "Set how many of your ", barn, " ", barn > 1 ? 'horses' : 'horse', " are on each dose."), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-lvl"
    }, picked.map(k => {
      const p = BY_KEY[k];
      const lv = levels[k] || {
        maint: barn,
        perf: 0
      };
      const hydra = k === 'hydra-max';
      const maintDose = hydra ? '8 oz a day' : '1 oz a day';
      const perfDose = hydra ? '16 oz a day' : '2 oz a day';
      const perfLabel = hydra ? 'Performance' : 'Performance / loading';
      return /*#__PURE__*/React.createElement("div", {
        className: "bx-plan-lvlrow",
        key: k
      }, /*#__PURE__*/React.createElement("div", {
        className: "top"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ic",
        style: {
          background: p.accent
        }
      }, /*#__PURE__*/React.createElement(PlanGlyph, {
        p: p
      })), p.name), /*#__PURE__*/React.createElement("div", {
        className: "bx-plan-counts"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bx-plan-count"
      }, /*#__PURE__*/React.createElement("label", null, "Maintenance ", /*#__PURE__*/React.createElement("span", {
        className: "dose"
      }, maintDose)), /*#__PURE__*/React.createElement(PlanMini, {
        value: lv.maint,
        max: barn,
        onChange: v => setLvl(k, 'maint', v)
      })), /*#__PURE__*/React.createElement("div", {
        className: "bx-plan-count"
      }, /*#__PURE__*/React.createElement("label", null, perfLabel, " ", /*#__PURE__*/React.createElement("span", {
        className: "dose"
      }, perfDose)), /*#__PURE__*/React.createElement(PlanMini, {
        value: lv.perf,
        max: barn,
        onChange: v => setLvl(k, 'perf', v)
      }))), hydra && /*#__PURE__*/React.createElement("p", {
        className: "bx-plan-lvlnote"
      }, "Fed daily in 3–4 gallons of water."));
    })), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-nav"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bx-plan-ghost",
      onClick: () => setStep(2)
    }, "Back"), /*#__PURE__*/React.createElement("button", {
      className: "bx-btn bx-btn-primary",
      onClick: () => setStep(4)
    }, "Build my plan"))), step === 4 && /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-result"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-q",
      style: {
        marginBottom: 4
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "bx-plan-reseyebrow"
    }, "Your barn’s plan"), /*#__PURE__*/React.createElement("h3", null, "Here’s what to put on auto-ship."), /*#__PURE__*/React.createElement("p", null, "Sized for ", barn, " ", barn > 1 ? 'horses' : 'horse', ", shipped every 90 days. Adjust anytime.")), planKeys.length === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-empty"
    }, "Set at least one horse on a protocol to see your plan.") : /*#__PURE__*/React.createElement(React.Fragment, null, hasStressMaint ? /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-reserve"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-reserve-head"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lab"
    }, "Show, travel & weather"), /*#__PURE__*/React.createElement("span", {
      className: "val"
    }, events === 0 ? 'None' : events >= 24 ? '24+ a year' : events + ' a year')), /*#__PURE__*/React.createElement("input", {
      className: "bx-plan-slider",
      type: "range",
      min: "0",
      max: "24",
      step: "1",
      style: {
        '--fill': events / 24 * 100 + '%'
      },
      value: events,
      onChange: e => setEvents(parseInt(e.target.value, 10))
    }), /*#__PURE__*/React.createElement("p", {
      className: "bx-plan-reserve-help"
    }, "Shows & hauling, big weather swings, a move or new pasture mates, hard training, injury or extensive stall rest, vet work. We’ll keep a little extra gut, calm, and hydration support on hand for the hard weeks.")) : /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-reserve"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-reserve-head"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lab"
    }, "Your dosing")), /*#__PURE__*/React.createElement("ul", {
      className: "bx-plan-confirm"
    }, picked.map(k => {
      const lv = levels[k] || {
        maint: barn,
        perf: 0
      };
      const parts = [];
      if (lv.maint > 0) parts.push(lv.maint + ' on maintenance');
      if (lv.perf > 0) parts.push(lv.perf + ' on performance');
      return /*#__PURE__*/React.createElement("li", {
        key: k
      }, /*#__PURE__*/React.createElement("span", {
        className: "nm"
      }, /*#__PURE__*/React.createElement("span", {
        className: "dot",
        style: {
          background: BY_KEY[k].accent
        }
      }), BY_KEY[k].name), /*#__PURE__*/React.createElement("span", {
        className: "mx"
      }, parts.join('  \u00b7  ')));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-lines"
    }, finalKeys.map(k => {
      const p = BY_KEY[k];
      const u = /bucket/i.test(p.unit) ? 'bucket' : 'gallon';
      const res = reserveCart[k] || 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "bx-plan-line",
        key: k
      }, /*#__PURE__*/React.createElement("span", {
        className: "nm"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ic",
        style: {
          background: p.accent
        }
      }, /*#__PURE__*/React.createElement(PlanGlyph, {
        p: p
      })), p.name), /*#__PURE__*/React.createElement("span", {
        className: "qty"
      }, /*#__PURE__*/React.createElement("span", {
        className: "q"
      }, finalCart[k], " ", u, finalCart[k] > 1 ? 's' : '', " · every 90 days"), res > 0 && /*#__PURE__*/React.createElement("span", {
        className: "resnote"
      }, "includes +", res, " reserve")));
    })), finalKeys.some(k => /bucket/i.test(BY_KEY[k].unit)) && /*#__PURE__*/React.createElement("p", {
      className: "bx-plan-linecap"
    }, "Everything ships together every 90 days. Hydra-MAX comes as 30-day buckets, so the count is what your barn goes through across the full cycle."), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-total"
    }, /*#__PURE__*/React.createElement("div", {
      className: "lab"
    }, "Your plan, on subscription"), /*#__PURE__*/React.createElement("div", {
      className: "amt"
    }, money(pr.total), " ", /*#__PURE__*/React.createElement("span", {
      className: "was"
    }, money(pr.retail))), /*#__PURE__*/React.createElement("div", {
      className: "save"
    }, "Save ", money(pr.save), " (", Math.round(pr.pct * 100), "% off) every 90 days"))), /*#__PURE__*/React.createElement("div", {
      className: "bx-plan-nav"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bx-plan-ghost",
      onClick: () => setStep(3)
    }, "Adjust"), /*#__PURE__*/React.createElement("button", {
      className: "bx-btn bx-btn-primary",
      disabled: planKeys.length === 0,
      onClick: () => onApply(finalCart)
    }, "Add this plan to my cart"))));
  }

  /* ---------------- Popular stacks (current product leads the grid) ---------------- */
  /* ---------------- Full 100X line (cross-sell, current product first) ---------------- */
  const LINE_DESC = {
    'gut-x': 'Liquid gut health and immune support, the foundation every other protocol builds on.',
    'osteo-max': 'Bone density, joint integrity, and recovery for hard-working and aging horses.',
    'joint-flex-plus': 'Everyday joint flexibility and comfort for performance and senior horses.',
    'amino-max': 'Amino acids for topline, muscle, and a stronger frame under saddle.',
    'hydra-max': 'Electrolyte and hydration support for sweat, travel, and hot, hard days.',
    'max-calm': 'Liquid calming support for focus and rideability, without the dullness.'
  };
  // current product first (anchor), then the rest of the line in catalog order
  function orderedLine() {
    return PRODUCTS.map((p, i) => [p, i]).sort((a, b) => a[0].key === CURRENT_KEY ? -1 : b[0].key === CURRENT_KEY ? 1 : a[1] - b[1]).map(x => x[0]);
  }
  function PopularStacks({
    mode,
    cart,
    onAddStack
  }) {
    const [added, setAdded] = useState(null);
    const list = orderedLine();
    const handleAdd = p => {
      onAddStack({
        [p.key]: 1
      }, p.name);
      setAdded(p.key);
      setTimeout(() => setAdded(a => a === p.key ? null : a), 1600);
    };
    return /*#__PURE__*/React.createElement("section", {
      className: "bx-stacks"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bx-stacks-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "bx-eyebrow"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dot"
    }), "The full system"), /*#__PURE__*/React.createElement("h2", null, "Pair Gut X with another protocol.")), /*#__PURE__*/React.createElement("p", {
      className: "bx-stacks-lede-lg"
    }, "Stack more and save up to 40% off. Adjust anytime.")), /*#__PURE__*/React.createElement("div", {
      className: "bx-stack-grid bx-stack-grid--line"
    }, list.map(p => {
      const isCurrent = p.key === CURRENT_KEY;
      const unit = productPrice(p, 1);
      const sub = round2(unit * (1 - SUB_DISCOUNT));
      return /*#__PURE__*/React.createElement("article", {
        className: 'bx-stack bx-line-card' + (isCurrent ? ' is-current' : ''),
        key: p.key
      }, isCurrent && /*#__PURE__*/React.createElement("span", {
        className: "bx-stack-flag"
      }, "You’re viewing"), /*#__PURE__*/React.createElement("div", {
        className: "bx-stack-top"
      }, /*#__PURE__*/React.createElement("span", {
        className: "bx-stack-for"
      }, /*#__PURE__*/React.createElement("span", {
        className: "bx-line-dot",
        style: {
          background: p.accent
        }
      }), p.cat), /*#__PURE__*/React.createElement("h3", null, p.name), /*#__PURE__*/React.createElement("p", {
        className: "bx-stack-blurb"
      }, LINE_DESC[p.key] || p.bestFor)), /*#__PURE__*/React.createElement("div", {
        className: "bx-stack-foot"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bx-stack-pricing"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bx-stack-price-row"
      }, /*#__PURE__*/React.createElement("span", {
        className: "bx-stack-price"
      }, "$", sub.toFixed(2)), /*#__PURE__*/React.createElement("span", {
        className: "bx-stack-was"
      }, "$", unit.toFixed(2))), /*#__PURE__*/React.createElement("span", {
        className: "bx-stack-meta"
      }, "Subscribe price")), /*#__PURE__*/React.createElement("button", {
        className: 'bx-stack-add' + (added === p.key ? ' is-added' : ''),
        onClick: e => {
          e.stopPropagation();
          handleAdd(p);
        }
      }, added === p.key ? 'Added \u2713' : (cart[p.key] || 0) > 0 ? 'Add another' : 'Add')));
    })));
  }

  /* ---------------- Slide-out cart drawer ---------------- */
  const Check = /*#__PURE__*/React.createElement("svg", {
    className: "ck",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));

  /* In-drawer cross-sell: recommend protocols not yet in the cart so "add more"
     is an obvious next tap. Adding one moves it from the rail into the line items. */
  const XSELL_ORDER = ['osteo-max', 'joint-flex-plus', 'max-calm', 'amino-max', 'hydra-max'];
  function XSell({
    cart,
    onAdd
  }) {
    const recs = XSELL_ORDER.filter(k => BY_KEY[k] && !(cart[k] > 0)).slice(0, 3).map(k => BY_KEY[k]);
    if (recs.length === 0) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-xsell"
    }, /*#__PURE__*/React.createElement("p", {
      className: "gx-dr-xsell-h"
    }, "Complete the protocol"), /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-xrow"
    }, recs.map(p => /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-xcard",
      key: p.key
    }, p.img ? /*#__PURE__*/React.createElement("img", {
      className: "gx-dr-xthumb",
      src: p.img,
      alt: p.name
    }) : /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-xthumb gx-dr-xthumb--ph",
      style: {
        background: p.accent
      },
      "aria-hidden": "true"
    }, p.name[0]), /*#__PURE__*/React.createElement("div", {
      className: "nm"
    }, p.name), /*#__PURE__*/React.createElement("div", {
      className: "cat"
    }, p.cat), /*#__PURE__*/React.createElement("div", {
      className: "pr"
    }, money(productPrice(p, 1))), /*#__PURE__*/React.createElement("button", {
      className: "gx-dr-xadd",
      onClick: () => onAdd(p.key),
      "aria-label": 'Add ' + p.name
    }, "+ Add")))));
  }
  /* Empty-cart shortcuts. Deliberately only two: the single product most barns
     start with, and the pair. Prices are computed live by the same pricer the
     rest of the drawer uses, so they never drift from the catalog. */
  const EMPTY_PICKS = [{
    items: {
      'gut-x': 1
    },
    name: 'Gut X',
    sub: 'Gut & immune, the foundation'
  }, {
    items: {
      'gut-x': 1,
      'osteo-max': 1
    },
    name: 'The Foundation Stack',
    sub: 'Gut X + Osteo-MAX'
  }];
  function CartDrawer({
    open,
    cart,
    mode,
    setMode,
    cadence,
    setCadence,
    onQty,
    onRemove,
    onAdd,
    onClose,
    onViewFull
  }) {
    const sub = priceCart(cart, 'sub');
    const one = priceCart(cart, 'one');
    const pr = mode === 'sub' ? sub : one;
    const hasGut = (cart['gut-x'] || 0) > 0;
    const animTotal = useAnimatedNumber(pr.total);
    const animSave = useAnimatedNumber(pr.save);
    const subPct = Math.round((sub.retail - sub.total) / Math.max(sub.retail, 1) * 100);
    const onePct = Math.round((one.retail - one.total) / Math.max(one.retail, 1) * 100);
    const empty = pr.keys.length === 0;
    const [openRow, setOpenRow] = useState(null);
    // Lock background scroll while the drawer is open (kills the double scrollbar)
    React.useEffect(() => {
      if (open) {
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
          document.body.style.overflow = prev;
        };
      }
    }, [open]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "gx-drawer-scrim",
      "data-open": open,
      onClick: onClose
    }), /*#__PURE__*/React.createElement("aside", {
      className: "gx-drawer",
      "data-open": open,
      "aria-hidden": !open,
      role: "dialog",
      "aria-label": "Your cart"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-drawer-head"
    }, /*#__PURE__*/React.createElement("h3", null, "Your cart", !empty && /*#__PURE__*/React.createElement("span", {
      className: "cnt"
    }, pr.units)), /*#__PURE__*/React.createElement("button", {
      className: "gx-drawer-close",
      onClick: onClose,
      "aria-label": "Close cart"
    }, "×")), !empty && /*#__PURE__*/React.createElement("a", {
      className: "gx-dr-viewfull top",
      href: "Bundles.html?from=cart"
    }, "View full cart & add more →"), empty ? /*#__PURE__*/React.createElement("div", {
      className: "gx-drawer-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-empty"
    }, /*#__PURE__*/React.createElement("span", {
      className: "gx-empty-ic",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "9",
      cy: "21",
      r: "1"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "20",
      cy: "21",
      r: "1"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
    }))), /*#__PURE__*/React.createElement("b", {
      className: "gx-empty-h"
    }, "Your cart is empty"), /*#__PURE__*/React.createElement("p", {
      className: "gx-empty-p"
    }, "Most barns start with the gut and build from there."), /*#__PURE__*/React.createElement("div", {
      className: "gx-empty-lbl"
    }, "Start here"), /*#__PURE__*/React.createElement("div", {
      className: "gx-empty-picks"
    }, EMPTY_PICKS.map(pick => {
      const q = priceCart(pick.items, 'sub');
      const pct = Math.round(q.pct * 100);
      return /*#__PURE__*/React.createElement("button", {
        className: "gx-empty-pick",
        key: pick.name,
        onClick: () => onAdd(pick.items, pick.name)
      }, /*#__PURE__*/React.createElement("span", {
        className: "ep-tx"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ep-nm"
      }, pick.name, pct > 20 && /*#__PURE__*/React.createElement("span", {
        className: "ep-save"
      }, "Save ", pct, "%")), /*#__PURE__*/React.createElement("span", {
        className: "ep-sub"
      }, pick.sub)), /*#__PURE__*/React.createElement("span", {
        className: "ep-px"
      }, money(q.total)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "gx-empty-calc"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-empty-calc-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-empty-calc-tx"
    }, /*#__PURE__*/React.createElement("b", null, "How much should I order?"), /*#__PURE__*/React.createElement("span", null, "Answer 4 questions & we’ll size it for you.")), /*#__PURE__*/React.createElement("span", {
      className: "gx-empty-calc-ic",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "15",
      height: "15",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "5",
      y: "3",
      width: "14",
      height: "18",
      rx: "2"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "8",
      y1: "7",
      x2: "16",
      y2: "7"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "8",
      y1: "11",
      x2: "8",
      y2: "11"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "12",
      y1: "11",
      x2: "12",
      y2: "11"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "16",
      y1: "11",
      x2: "16",
      y2: "11"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "8",
      y1: "15",
      x2: "8",
      y2: "15"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "12",
      y1: "15",
      x2: "12",
      y2: "15"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "16",
      y1: "15",
      x2: "16",
      y2: "17"
    })))), CART_ONLY ? /*#__PURE__*/React.createElement("a", {
      className: "gx-empty-calc-link",
      href: "Bundles.html"
    }, "Quick Calculator ", /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "→")) : /*#__PURE__*/React.createElement("button", {
      className: "gx-empty-calc-link",
      type: "button",
      "data-jump-barn": "true",
      onClick: onClose
    }, "Quick Calculator ", /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "→"))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "gx-drawer-body"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "gx-dr-lines"
    }, pr.keys.map(k => {
      const p = BY_KEY[k];
      return /*#__PURE__*/React.createElement("li", {
        className: "gx-dr-line",
        key: k
      }, /*#__PURE__*/React.createElement("div", {
        className: "gx-dr-qty"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: () => onQty(k, cart[k] - 1),
        "aria-label": "Decrease"
      }, "–"), /*#__PURE__*/React.createElement("span", null, cart[k]), /*#__PURE__*/React.createElement("button", {
        onClick: () => onQty(k, cart[k] + 1),
        "aria-label": "Increase"
      }, "+")), /*#__PURE__*/React.createElement("div", {
        className: "gx-dr-nm"
      }, /*#__PURE__*/React.createElement("b", null, p.name), /*#__PURE__*/React.createElement("small", null, p.cat, " Support")), /*#__PURE__*/React.createElement("span", {
        className: "gx-dr-lp"
      }, money(pr.lines[k])), /*#__PURE__*/React.createElement("button", {
        className: "gx-dr-rm",
        onClick: () => onRemove(k),
        "aria-label": 'Remove ' + p.name
      }, "×"));
    })), /*#__PURE__*/React.createElement("div", {
      className: 'gx-dr-row' + (openRow === 'ptype' ? ' open' : '')
    }, /*#__PURE__*/React.createElement("button", {
      className: "gx-dr-rowbtn",
      onClick: () => setOpenRow(openRow === 'ptype' ? null : 'ptype')
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "rl"
    }, "Purchase type"), /*#__PURE__*/React.createElement("div", {
      className: "rv"
    }, mode === 'sub' ? 'Subscribe & Save' + (subPct > 0 ? ' \u00b7 ' + subPct + '% off' : '') : 'One-time purchase')), /*#__PURE__*/React.createElement("span", {
      className: "chev"
    }, "›")), /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-rowbody"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bx-ptype",
      "data-on": mode === 'sub',
      onClick: () => setMode('sub')
    }, /*#__PURE__*/React.createElement("span", {
      className: "radio"
    }), /*#__PURE__*/React.createElement("div", {
      className: "bx-ptype-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bx-ptype-top"
    }, /*#__PURE__*/React.createElement("span", {
      className: "t"
    }, "Subscribe & Save"), subPct > 0 && /*#__PURE__*/React.createElement("span", {
      className: "savepill"
    }, "Save ", subPct, "%")), /*#__PURE__*/React.createElement("ul", {
      className: "bx-ptype-perks"
    }, /*#__PURE__*/React.createElement("li", null, "Free shipping"), hasGut && /*#__PURE__*/React.createElement("li", {
      className: "coral"
    }, "$20,000 Colic Care Coverage"), /*#__PURE__*/React.createElement("li", null, "Pause, change, or cancel anytime"))), /*#__PURE__*/React.createElement("div", {
      className: "bx-ptype-price"
    }, /*#__PURE__*/React.createElement("span", {
      className: "was"
    }, money(sub.retail)), /*#__PURE__*/React.createElement("span", {
      className: "now"
    }, money(sub.total)))), /*#__PURE__*/React.createElement("button", {
      className: "bx-ptype",
      "data-on": mode === 'one',
      onClick: () => setMode('one')
    }, /*#__PURE__*/React.createElement("span", {
      className: "radio"
    }), /*#__PURE__*/React.createElement("div", {
      className: "bx-ptype-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bx-ptype-top"
    }, /*#__PURE__*/React.createElement("span", {
      className: "t"
    }, "One-time purchase")), /*#__PURE__*/React.createElement("ul", {
      className: "bx-ptype-perks"
    }, /*#__PURE__*/React.createElement("li", null, "Ships once. No Colic Care Coverage."))), /*#__PURE__*/React.createElement("div", {
      className: "bx-ptype-price"
    }, onePct > 0 && /*#__PURE__*/React.createElement("span", {
      className: "was"
    }, money(one.retail)), /*#__PURE__*/React.createElement("span", {
      className: "now"
    }, money(one.total)))))), mode === 'sub' && /*#__PURE__*/React.createElement("div", {
      className: 'gx-dr-row' + (openRow === 'cad' ? ' open' : '')
    }, /*#__PURE__*/React.createElement("button", {
      className: "gx-dr-rowbtn",
      onClick: () => setOpenRow(openRow === 'cad' ? null : 'cad')
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "rl"
    }, "Delivery time"), /*#__PURE__*/React.createElement("div", {
      className: "rv"
    }, "Every ", cadence, " days", cadence === '90' ? ' \u00b7 Recommended' : '')), /*#__PURE__*/React.createElement("span", {
      className: "chev"
    }, "›")), /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-rowbody"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bx-cadence-seg"
    }, [['60', 'Top-up'], ['90', 'Recommended'], ['120', 'Stock up']].map(([v, l]) => /*#__PURE__*/React.createElement("button", {
      key: v,
      "data-on": cadence === v,
      onClick: () => setCadence(v)
    }, v, " days", /*#__PURE__*/React.createElement("span", {
      className: "sub"
    }, l)))))), mode === 'sub' && hasGut && /*#__PURE__*/React.createElement("div", {
      className: 'gx-dr-row' + (openRow === 'colic' ? ' open' : '')
    }, /*#__PURE__*/React.createElement("button", {
      className: "gx-dr-rowbtn",
      onClick: () => setOpenRow(openRow === 'colic' ? null : 'colic')
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "rl"
    }, "Included with subscription"), /*#__PURE__*/React.createElement("div", {
      className: "rv"
    }, "$20,000 Colic Coverage \u00b7 30-day qualifying period")), /*#__PURE__*/React.createElement("span", {
      className: "chev"
    }, "›")), /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-rowbody"
    }, /*#__PURE__*/React.createElement("p", {
      className: "note"
    }, "Enrollment form + a qualifying subscription. Reimbursement eligibility begins after a 30-day qualifying period from acceptance. Terms apply.")))), /*#__PURE__*/React.createElement("div", {
      className: "gx-drawer-foot"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-totrow"
    }, /*#__PURE__*/React.createElement("span", {
      className: "tl"
    }, "Subtotal"), /*#__PURE__*/React.createElement("span", {
      className: "tv"
    }, money(animTotal))), pr.save > 0.005 && /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-saverow"
    }, /*#__PURE__*/React.createElement("span", null, "You’re saving ", money(animSave), " (", Math.round(pr.pct * 100), "% off retail)"), /*#__PURE__*/React.createElement("s", null, money(pr.retail))), /*#__PURE__*/React.createElement("button", {
      className: "gx-dr-checkout",
      onClick: () => {
        // Was: location.href = 'Checkout.html' (leftover static mockup). This drawer is the shared
        // site-wide checkout (Bundles page, home and shop all mount it), so it hands the cart to
        // gx-bundle-checkout.js -> real variants + selling plans -> /checkout. cart/mode/cadence are
        // CartDrawer props; guard on empty and on the resolver being present on the page.
        if (!empty && window.GXBundleCheckout) window.GXBundleCheckout(cart, mode, cadence);
      }
    }, /*#__PURE__*/React.createElement("span", null, "Checkout"), /*#__PURE__*/React.createElement("span", {
      className: "cp"
    }, "→")), /*#__PURE__*/React.createElement("div", {
      className: "bx-pay"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bx-pay-shop",
      "aria-label": "Shop Pay"
    }, "shop", /*#__PURE__*/React.createElement("b", null, "Pay")), /*#__PURE__*/React.createElement("button", {
      className: "bx-pay-pp",
      "aria-label": "PayPal"
    }, /*#__PURE__*/React.createElement("b", null, "Pay"), "Pal")), /*#__PURE__*/React.createElement("p", {
      className: "gx-dr-note"
    }, "Free shipping · 90-day money-back · Cancel anytime"), /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-secure"
    }, /*#__PURE__*/React.createElement("p", {
      className: "gx-dr-ssl"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "11",
      width: "18",
      height: "11",
      rx: "2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 11V7a5 5 0 0 1 10 0v4"
    })), "SSL-encrypted checkout"), /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-cards",
      "aria-label": "Accepted cards"
    }, /*#__PURE__*/React.createElement("img", {
      src: window.BA["visa.svg"],
      alt: "Visa"
    }), /*#__PURE__*/React.createElement("img", {
      src: window.BA["mastercard.svg"],
      alt: "Mastercard"
    }), /*#__PURE__*/React.createElement("img", {
      src: window.BA["amex.svg"],
      alt: "American Express"
    }), /*#__PURE__*/React.createElement("img", {
      src: window.BA["discover.svg"],
      alt: "Discover"
    })))))));
  }

  /* ---------------- Calculator drawer (hosts the Barn Plan wizard) ---------------- */
  function CalcDrawer({
    open,
    onClose,
    onApply
  }) {
    const [wizStep, setWizStep] = useState(1);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "gx-drawer-scrim",
      "data-open": open,
      onClick: onClose
    }), /*#__PURE__*/React.createElement("aside", {
      className: "gx-drawer gx-calc",
      "data-open": open,
      "aria-hidden": !open,
      role: "dialog",
      "aria-label": "Barn Plan Builder"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-drawer-head"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-calc-htext"
    }, /*#__PURE__*/React.createElement("span", {
      className: "gx-calc-eyebrow"
    }, "Barn Plan Builder"), /*#__PURE__*/React.createElement("span", {
      className: "t"
    }, "How much should I order?")), /*#__PURE__*/React.createElement("button", {
      className: "gx-drawer-close",
      onClick: onClose,
      "aria-label": "Close"
    }, "×")), /*#__PURE__*/React.createElement("div", {
      className: "gx-calc-body"
    }, wizStep === 1 && /*#__PURE__*/React.createElement("p", {
      className: "gx-calc-intro"
    }, "Answer 4 quick questions and we’ll size your supply for you. No guesswork, no running short."), open && /*#__PURE__*/React.createElement(BarnPlanner, {
      onApply: onApply,
      onStep: setWizStep
    }))));
  }

  /* ---------------- Module host ---------------- */
  // data-cart-only on #gx-bundle-root = universal-cart mount (drawer + toast only, no PDP sections)
  const CART_ONLY = (() => {
    try {
      const r = document.getElementById('gx-bundle-root');
      return !!(r && r.hasAttribute('data-cart-only'));
    } catch (e) {
      return false;
    }
  })();
  // data-calc-only = PDP mount: ONLY the Quick Calculator drawer. The cart there belongs to
  // gx-cart-v2, so every cart-facing listener and render below must stay off in this mode.
  const CALC_ONLY = (() => {
    try {
      const r = document.getElementById('gx-bundle-root');
      return !!(r && r.hasAttribute('data-calc-only'));
    } catch (e) {
      return false;
    }
  })();
  function BundleModule() {
    const readLS = (k, ok, fb) => {
      try {
        const v = localStorage.getItem(k);
        return ok(v) ? v : fb;
      } catch (e) {
        return fb;
      }
    };
    const readCart = () => {
      try {
        const c = JSON.parse(localStorage.getItem('bx_cart') || '{}');
        return c && typeof c === 'object' ? c : {};
      } catch (e) {
        return {};
      }
    };
    const [cart, setCart] = useState(readCart);
    const [mode, setMode] = useState(() => readLS('bx_mode', v => v === 'one' || v === 'sub', 'sub'));
    const [cadence, setCadence] = useState(() => readLS('bx_cadence', v => ['60', '90', '120'].includes(v), '90'));
    // demo: ?cartopen=1 opens the cart drawer on load (for design review)
    const [drawer, setDrawer] = useState(() => {
      try {
        return new URLSearchParams(location.search).get('cartopen') === '1';
      } catch (e) {
        return false;
      }
    });
    const [calcOpen, setCalcOpen] = useState(false);
    const [toast, setToast] = useState(null);
    const setQty = (k, q) => setCart(c => {
      const n = {
        ...c
      };
      if (q <= 0) delete n[k];else n[k] = q;
      return n;
    });
    const removeItem = k => setCart(c => {
      const n = {
        ...c
      };
      delete n[k];
      return n;
    });
    const fireToast = msg => {
      setToast({
        msg,
        id: Date.now()
      });
      setTimeout(() => setToast(t => t && Date.now() - t.id >= 1900 ? null : t), 2000);
    };

    // MERGE (never wipe) + open the drawer — the PDP cart model
    const addStack = (items, label) => {
      setCart(c => {
        const n = {
          ...c
        };
        Object.entries(items).forEach(([k, q]) => {
          n[k] = (n[k] || 0) + q;
        });
        return n;
      });
      setMode('sub');
      setDrawer(true);
      fireToast((label || 'Stack') + ' added to cart');
    };
    const applyPlan = plan => {
      if (CALC_ONLY) {
        // Persist synchronously (no effect will run before the redirect) and hand off to the
        // bundles page, which hydrates bx_cart/bx_mode into the builder. Subscribe preselected.
        try {
          let c = {};
          try { c = JSON.parse(localStorage.getItem('bx_cart') || '{}') || {}; } catch (e) {}
          Object.entries(plan).forEach(([k, q]) => {
            c[k] = (c[k] || 0) + q;
          });
          localStorage.setItem('bx_cart', JSON.stringify(c));
          localStorage.setItem('bx_mode', 'sub');
        } catch (e) {}
        window.location.assign('/pages/bundles');
        return;
      }
      setCart(c => {
        const n = {
          ...c
        };
        Object.entries(plan).forEach(([k, q]) => {
          n[k] = (n[k] || 0) + q;
        });
        return n;
      });
      setMode('sub');
      setCalcOpen(false);
      setDrawer(true);
      fireToast('Your barn plan was added');
    };

    // persist the cart so "View full cart & add more" can hydrate the Bundles page
    useEffect(() => {
      try {
        localStorage.setItem('bx_cart', JSON.stringify(cart));
        localStorage.setItem('bx_mode', mode);
        localStorage.setItem('bx_cadence', cadence);
      } catch (e) {}
      window.dispatchEvent(new CustomEvent('bx:cart-sync', {
        detail: {
          src: 'drawer'
        }
      }));
    }, [cart, mode, cadence]);
    // another cart owner on this page (e.g. the Bundles builder) changed the shared cart: re-hydrate
    useEffect(() => {
      const on = e => {
        if (e.detail && e.detail.src === 'drawer') return;
        const c = readCart();
        setCart(p => JSON.stringify(p) === JSON.stringify(c) ? p : c);
        setMode(readLS('bx_mode', v => v === 'one' || v === 'sub', 'sub'));
        setCadence(readLS('bx_cadence', v => ['60', '90', '120'].includes(v), '90'));
      };
      window.addEventListener('bx:cart-sync', on);
      return () => window.removeEventListener('bx:cart-sync', on);
    }, []);
    // site-wide nav cart badge
    useEffect(() => {
      if (CALC_ONLY) return;
      const n = Object.values(cart).reduce((a, b) => a + (b || 0), 0);
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = '(' + n + ')';
      });
    }, [cart]);

    // relocate this module into the section flow: replace the old cross-sell block
    useEffect(() => {
      if (CART_ONLY || CALC_ONLY) return;
      const host = document.getElementById('gx-bundle-root');
      const secRoot = document.getElementById('gx-sections-root');
      if (!host || !secRoot) return;
      const tryPlace = () => {
        const cross = secRoot.querySelector('[data-screen-label="13 Cross-sell"]');
        if (cross) {
          cross.parentNode.insertBefore(host, cross);
          cross.remove();
          return true;
        }
        return false;
      };
      if (!tryPlace()) {
        // sections render async — retry briefly
        let tries = 0;
        const iv = setInterval(() => {
          if (tryPlace() || ++tries > 40) clearInterval(iv);
        }, 80);
        return () => clearInterval(iv);
      }
    }, []);

    // Place the slim entry band: under the FAQ on desktop (leads into the
    // builder section just below), inside the buy-box column on mobile.
    // Mobile placement is provisional — revisit later.
    useEffect(() => {
      if (CART_ONLY || CALC_ONLY) return;
      const band = document.querySelector('.gx-barn-entry');
      const col = document.querySelector('.info-col');
      if (!band || !col) return;
      const mq = window.matchMedia('(min-width: 900px)');
      const secRoot = document.getElementById('gx-sections-root');
      const place = () => {
        if (mq.matches) {
          // desktop → as the last item inside the first FAQ ("Common Questions") list
          const list = document.querySelector('.gx-cq-list');
          if (list && band.parentElement !== list) {
            band.classList.remove('gx-barn-entry--wide');
            list.appendChild(band);
          }
        } else {
          // mobile → down near the bottom, just before the Common Questions / FAQ
          band.classList.remove('gx-barn-entry--wide');
          const cq = document.querySelector('.gx-cq');
          const faq = document.querySelector('#gx-sections-root [data-screen-label="12 FAQ"]');
          const anchor = cq || faq;
          if (anchor && band.nextElementSibling !== anchor) anchor.parentNode.insertBefore(band, anchor);
        }
      };
      place();
      // sections render async — retry briefly so the FAQ target exists
      let tries = 0;
      const iv = setInterval(() => {
        place();
        if (++tries > 40) clearInterval(iv);
      }, 80);
      mq.addEventListener('change', place);
      return () => {
        clearInterval(iv);
        mq.removeEventListener('change', place);
      };
    }, []);

    // Extra Quick Calculator triggers around the page — all open the same drawer.
    // Injected into existing markup (buy box + Protocol section) so they can be
    // reverted by simply removing this block. Guarded so they insert only once.
    useEffect(() => {
      if (CART_ONLY || CALC_ONLY) return;
      const CALC_SVG = '<span class="ic" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2"/><line x1="8" y1="7" x2="16" y2="7"/><line x1="8" y1="11" x2="8" y2="11"/><line x1="12" y1="11" x2="12" y2="11"/><line x1="16" y1="11" x2="16" y2="11"/><line x1="8" y1="15" x2="8" y2="15"/><line x1="12" y1="15" x2="12" y2="15"/><line x1="16" y1="15" x2="16" y2="17"/></svg></span>';
      const place = () => {
        // 1) buy box — trigger removed on request (the subscribe area has enough).
        // 2) Protocol section — the dark card, centered
        const proto = document.querySelector('[data-screen-label="07 Protocol"] .gx-wrap-tight');
        if (proto && !document.querySelector('.gx-barn-entry--proto')) {
          const wrap = document.createElement('div');
          wrap.className = 'gx-barn-entry gx-barn-entry--proto';
          wrap.innerHTML = '<div class="gx-barn-entry-inner">' + '<button class="gx-barn-entry-link" data-jump-barn>Quick Calculator &rarr;</button>' + '<span class="gx-barn-entry-tx"><b>How much should I order?</b>' + '<span>Answer 4 questions &amp; we\u2019ll size it for you.</span></span>' + '<span class="gx-barn-entry-ic" aria-hidden="true">' + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2"/><line x1="8" y1="7" x2="16" y2="7"/><line x1="8" y1="11" x2="8" y2="11"/><line x1="12" y1="11" x2="12" y2="11"/><line x1="16" y1="11" x2="16" y2="11"/><line x1="8" y1="15" x2="8" y2="15"/><line x1="12" y1="15" x2="12" y2="15"/><line x1="16" y1="15" x2="16" y2="17"/></svg>' + '</span>' + '</div>';
          proto.appendChild(wrap);
        }
      };
      place();
      let tries = 0;
      const iv = setInterval(() => {
        place();
        if (++tries > 40) clearInterval(iv);
      }, 80);
      return () => clearInterval(iv);
    }, []);

    // wire the Quick Calculator link to OPEN THE CALCULATOR DRAWER (no more scroll)
    useEffect(() => {
      const onClick = e => {
        const jump = e.target.closest('[data-jump-barn]');
        if (jump) {
          e.preventDefault();
          setCalcOpen(true);
        }
        const opener = e.target.closest('[data-open-cart]');
        if (opener && !CALC_ONLY) {
          e.preventDefault();
          setDrawer(true);
        }
      };
      document.addEventListener('click', onClick);
      return () => document.removeEventListener('click', onClick);
    }, []);

    // Buy-box + sticky mobile bar (a separate React root) ask us to add their
    // configured product and slide the cart open. detail: {items, label, mode, cadence}
    useEffect(() => {
      if (CALC_ONLY) return;
      const onAdd = e => {
        const d = e.detail || {};
        if (!d.items) return;
        setCart(c => {
          const n = {
            ...c
          };
          Object.entries(d.items).forEach(([k, q]) => {
            n[k] = (n[k] || 0) + q;
          });
          return n;
        });
        if (d.mode === 'one' || d.mode === 'sub') setMode(d.mode);
        if (d.cadence) setCadence(d.cadence);
        setDrawer(true);
        fireToast((d.label || 'Added') + ' added to cart');
      };
      window.addEventListener('gx:add-to-cart', onAdd);
      return () => window.removeEventListener('gx:add-to-cart', onAdd);
    }, []);
    if (CALC_ONLY) return /*#__PURE__*/React.createElement(CalcDrawer, {
      open: calcOpen,
      onClose: () => setCalcOpen(false),
      onApply: applyPlan
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, !CART_ONLY && /*#__PURE__*/React.createElement("div", {
      className: "gx-bundle-section"
    }, /*#__PURE__*/React.createElement(PopularStacks, {
      mode: mode,
      cart: cart,
      onAddStack: addStack
    })), !CART_ONLY && /*#__PURE__*/React.createElement(CalcDrawer, {
      open: calcOpen,
      onClose: () => setCalcOpen(false),
      onApply: applyPlan
    }), /*#__PURE__*/React.createElement(CartDrawer, {
      open: drawer,
      cart: cart,
      mode: mode,
      setMode: setMode,
      cadence: cadence,
      setCadence: setCadence,
      onQty: setQty,
      onRemove: removeItem,
      onAdd: addStack,
      onClose: () => setDrawer(false)
    }), toast && /*#__PURE__*/React.createElement("div", {
      className: "gx-dr-toast",
      "data-show": "true",
      key: toast.id
    }, Check, toast.msg));
  }
  const root = document.getElementById('gx-bundle-root');
  if (root) ReactDOM.createRoot(root).render(/*#__PURE__*/React.createElement(BundleModule, null));
})();
